import offerSchema from './offerSchema';

const responseOfferSchema = [offerSchema];

export default responseOfferSchema;
